import React, { useEffect, useState } from "react";

import { FaChevronDown } from "react-icons/fa6";
import "./PriceAndHeadingSection.css";
import tick2 from "../../../assets/tick2.svg";
import DOMPurify from "dompurify";
import ProductVariantsSection from "../ProductVariantsSection/ProductVariantsSection";
import { useSelector } from "react-redux";
import GuaranteedViewBox from "../GuaranteedViewBox/GuaranteedViewBox";
import useDeliveryDate from "./useDeliveryDate";

const PriceAndHeadingSection = ({
  propertiesLength,
  labelName,
  setLabelName,
  guaranteeHeading,
  guaranteeText,
  productName,
  productNameSection,
  handleSectionEditChange,
  productPriceSection,
  productPrice,
  showSalePrice,
  setShowSalePrice,
  guaranteeSection,
  productVariants,
  variantView,
  selectedProperty,
  setSelectedProperty,
  shipsFrom,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [guaranteeContent, setGuaranteeContent] = useState({});
  const { productData, matchedVariant, propertiesArray, selectedProperties } =
    useSelector((store) => store.productVariants);
  // delivery date range
 
  const { fromDate, toDate } = useDeliveryDate();

  useEffect(() => {
    setGuaranteeContent({
      guaranteeHeading: guaranteeHeading,
      guaranteeText: guaranteeText,
    });
  }, [guaranteeHeading, guaranteeText]);

   
  const handleGuaranteedClick = () => {
    handleSectionEditChange(["guaranteeHeadline", "guaranteeText"]);
    setExpanded(!expanded);
  };

  const calculateSavings = (regularPrice, salePrice) => {
    if (regularPrice && salePrice && regularPrice > salePrice) {
      return (((regularPrice - salePrice) / regularPrice) * 100).toFixed(2);
    }
    return 0;
  };

  const sectionText = DOMPurify.sanitize(guaranteeContent?.guaranteeText);

  const regularPrice = productPrice.price
    ? parseFloat(productPrice.price).toFixed(2) || 0.0
    : 0.0;
  const salePrice =
    showSalePrice &&
    !isNaN(parseFloat(productPrice.salePrice)) &&
    parseFloat(productPrice.salePrice) !== 0
      ? parseFloat(productPrice.salePrice).toFixed(2)
      : null;

  // const savings = salePrice ? calculateSavings(regularPrice, salePrice) : null;
  const [discountPercentage, setDiscountPercentage] = useState(0);

  useEffect(() => {
    setDiscountPercentage(
      regularPrice && salePrice
        ? (((regularPrice - salePrice) / regularPrice) * 100).toFixed(2)
        : 0
    );
  }, [salePrice, regularPrice]);
  return (
    <div className="heading-and-price-section-div">
      <div className="heading-and-price-section">
        {productName && (
          <h2
            id="productName"
            className={`${
              productNameSection ? "outline-border-selected" : "outline-border"
            }`}
            style={{ cursor: "pointer", width: "100%" }}
            onClick={() => handleSectionEditChange(["productName"])}
          >
            {productName}
          </h2>
        )}
        {propertiesLength <= 1 ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleSectionEditChange(["price"])}
            className={`product-price-section ${
              productPriceSection ? "outline-border-selected" : "outline-border"
            }`}
          >
            <div className="product-price-row">
              <span
                className={`price ${
                  salePrice ? "!text-[#5D6C7D] strikethrough" : ""
                }`}
              >
                ${regularPrice} USD
              </span>
              {salePrice && (
                <>
                  <span className="price">
                    ${salePrice} USD ({discountPercentage})%
                  </span>
                  <div className="sale-box">
                    <p style={{ fontSize: "16px", color: "white" }}>Sale</p>
                  </div>
                </>
              )}
            </div>

            <span className="tax">
              Tax included.{" "}
              <u
                style={{
                  textUnderlineOffset: "5px",
                }}
              >
                Shipping
              </u>{" "}
              calculated at checkout.
            </span>
          </div>
        ) : (
          <div
            style={{ cursor: "pointer" }}
            className={`product-price-section  `}
          >
            <div className="product-price-row">
              <span
                className={`price ${
                  salePrice ? "strikethrough !text-[#5D6C7D]" : ""
                }`}
              >
                ${regularPrice} USD
              </span>
              {salePrice && (
                <>
                  <span className="price !text-[#5D6C7D]">
                    ${salePrice} USD{" "}
                  </span>

                  <div className="sale-box">
                    <p style={{ fontSize: "16px", color: "white" }}>Sale</p>
                  </div>
                </>
              )}
            </div>
            {salePrice && (
              <div className="flex gap-2">
                <span className="text-red">You save:</span>
                <span>
                  {" "}
                  ${(regularPrice - salePrice).toFixed(2)} USD (
                  {discountPercentage})%
                </span>
              </div>
            )}

            <span className="tax">
              Tax included.{" "}
              <u
                style={{
                  textUnderlineOffset: "5px ",
                }}
              >
                Shipping
              </u>{" "}
              calculated at checkout.
            </span>
          </div>
        )}
        {propertiesLength > 1 && (
          <ProductVariantsSection
            labelName={labelName}
            setLabelName={setLabelName}
            variantView={variantView}
            handleSectionEditChange={handleSectionEditChange}
            productVariants={productVariants}
            selectedProperty={selectedProperty}
            setSelectedProperty={setSelectedProperty}
            shipsFrom={shipsFrom}
          />
        )}

        <button type="button" className="product-add-cart-button">
          ADD TO CART
        </button>
        <button type="button" className="product-buy-now-button">
          BUY NOW
        </button>
        <GuaranteedViewBox />

        <div
          className={`guaranted-results-container ${
            guaranteeSection ? "outline-border-selected" : "outline-border"
          }`}
        >
          <div
            onClick={handleGuaranteedClick}
            style={{ cursor: "pointer" }}
            className="guaranted-results-header"
          >
            {guaranteeContent?.guaranteeHeading && (
              <span className="guaranted-results-header-content">
                <img className="w-[14px] " src={tick2} alt="tick" />
                {guaranteeHeading}
              </span>
            )}
            <FaChevronDown color="#373b42" style={{ margin: "0 5px" }} />
          </div>
          {expanded && guaranteeContent?.guaranteeText && (
            <div className="expanded-content">
              <div dangerouslySetInnerHTML={{ __html: sectionText }}></div>
            </div>
          )}
        </div>
        <div className="product-shipping-range">
          <div style={{ display: "flex", alignItems: "center" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="svg-delivery"
              style={{
                display: "inline-block",
                width: "25px",
                height: "35px",
                float: "left",
                marginRight: "10px",
              }}
            >
              <path d="M422.512,215.424c0-0.079-0.004-0.158-0.005-0.237c-0.116-5.295-4.368-9.514-9.727-9.514h-2.554l-39.443-76.258 c-1.664-3.22-4.983-5.225-8.647-5.226l-67.34-0.014l2.569-20.364c0.733-8.138-1.783-15.822-7.086-21.638 c-5.293-5.804-12.683-9.001-20.81-9.001h-209c-5.255,0-9.719,4.066-10.22,9.308l-2.095,16.778h119.078 c7.732,0,13.836,6.268,13.634,14c-0.203,7.732-6.635,14-14.367,14H126.78c0.007,0.02,0.014,0.04,0.021,0.059H10.163 c-5.468,0-10.017,4.432-10.16,9.9c-0.143,5.468,4.173,9.9,9.641,9.9H164.06c7.168,1.104,12.523,7.303,12.326,14.808 c-0.216,8.242-7.039,14.925-15.267,14.994H54.661c-5.523,0-10.117,4.477-10.262,10c-0.145,5.523,4.215,10,9.738,10h105.204 c7.273,1.013,12.735,7.262,12.537,14.84c-0.217,8.284-7.109,15-15.393,15H35.792v0.011H25.651c-5.523,0-10.117,4.477-10.262,10 c-0.145,5.523,4.214,10,9.738,10h8.752l-3.423,35.818c-0.734,8.137,1.782,15.821,7.086,21.637 c5.292,5.805,12.683,9.001,20.81,9.001h7.55C69.5,333.8,87.3,349.345,109.073,349.345c21.773,0,40.387-15.545,45.06-36.118 h94.219c7.618,0,14.83-2.913,20.486-7.682 c5.172,4.964,12.028,7.682,19.514,7.682h1.55c3.597,20.573,21.397,36.118,43.171,36.118c21.773,0,40.387-15.545,45.06-36.118 h6.219c16.201,0,30.569-13.171,32.029-29.36l6.094-67.506c0.008-0.091,0.004-0.181,0.01-0.273 c0.01-0.139,0.029-0.275,0.033-0.415C422.52,215.589,422.512,215.508,422.512,215.424z M109.597,329.345 c-13.785,0-24.707-11.214-24.346-24.999 c0.361-13.786,11.87-25.001,25.655-25.001c13.785,0,24.706,11.215,24.345,25.001 C134.89,318.131,123.382,329.345,109.597,329.345z M333.597,329.345c-13.785,0-24.706-11.214-24.346-24.999 c0.361-13.786,11.87-25.001,25.655-25.001 c13.785,0,24.707,11.215,24.345,25.001C358.89,318.131,347.382,329.345,333.597,329.345z M396.457,282.588 c-0.52,5.767-5.823,10.639-11.58,10.639h-6.727c-4.454-19.453-21.744-33.882-42.721-33.882 c-20.977,0-39.022,14.429-44.494,33.882h-2.059c-2.542,0-4.81-0.953-6.389-2.685c-1.589-1.742-2.337-4.113-2.106-6.676 l12.609-139.691l28.959,0.006l-4.59,50.852 c-0.735,8.137,1.78,15.821,7.083,21.637c5.292,5.806,12.685,9.004,20.813,9.004h56.338L396.457,282.588z" />
            </svg>
            Get it between&nbsp;
            <span> {fromDate} - {toDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceAndHeadingSection;
